// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__PrMb9","description":"PatientConsentPreview_description__H4tvl"};